import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatStepperModule } from '@angular/material/stepper';
import { StepDisplayFormComponent } from './components/step-display-form/step-display-form.component';
import { StepDisplayHtmlComponent } from './components/step-display-html/step-display-html.component';
import { StepDisplayProductsComponent } from './components/step-display-products/step-display-products.component';
import { StepDisplaySummaryComponent } from './components/step-display-summary/step-display-summary.component';
import { StepDisplayTermsComponent } from './components/step-display-terms/step-display-terms.component';
import { StepDisplayVideoComponent } from './components/step-display-video/step-display-video.component';
import { StepperComponent } from './components/stepper/stepper.component';
import { TopBarComponent } from './components/top-bar/top-bar.component';
import { SaleComponent } from './sale.component';
import { SaleRoutesModule } from './sale.routes.module';
import { AddMandatoryStepsPipe } from './pipes/add-mandatory-steps.pipe';
import { ShowLabelsPipe } from './pipes/show-labels.pipe';
import { StepFormPipe } from './pipes/step-form.pipe';
import { SaleWorkflowComponent } from './views/sale-workflow/sale-workflow.component';
import { YoutubeVideoPlayerComponent } from './components/step-display-video/youtube-video-player/youtube-video-player.component';
import { HtmlVideoPlayerComponent } from './components/step-display-video/html-video-player/html-video-player.component';
import { StepDisplayFinalComponent } from './components/step-display-final/step-display-final.component';
import { CartComponent } from './components/cart/cart.component';
import { CartListComponent } from './components/cart-list/cart-list.component';
import { SlideOutComponent } from './components/slide-out/slide-out.component';
import { CatalogComponent } from './views/catalog/catalog.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormSelectComponent } from './components/form-field-select/form-select.component';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ProductCardComponent } from './components/product-card/product-card.component';
import { ProductCardAltComponent } from './components/product-card-alt/product-card-alt.component';
import { PaymentSuffixPipe } from '../shared/pipes/payment-suffix.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';
import { ProductDetailsDialogComponent } from './dialogs/product-details-dialog/product-details-dialog.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CategoryFilterComponent } from './components/category-filter/category-filter.component';
import { StepDisplayPromotionComponent } from './components/step-display-promotion/step-display-promotion.component';

@NgModule({
    declarations: [
        SaleComponent,
        SaleWorkflowComponent,
        CatalogComponent,
    ],
    imports: [
        CommonModule,
        SaleRoutesModule,
        MatStepperModule,
        MatCardModule,
        MatListModule,
        StepDisplayHtmlComponent,
        StepDisplaySummaryComponent,
        MatButtonModule,
        StepDisplayTermsComponent,
        StepFormPipe,
        StepDisplayFormComponent,
        StepDisplayVideoComponent,
        ShowLabelsPipe,
        YoutubeVideoPlayerComponent,
        HtmlVideoPlayerComponent,
        StepperComponent,
        TopBarComponent,
        AddMandatoryStepsPipe,
        StepDisplayProductsComponent,
        StepDisplayFinalComponent,
        CartComponent,
        CartListComponent,
        SlideOutComponent,
        ReactiveFormsModule,
        FormSelectComponent,
        MatOptionModule,
        MatInputModule,
        MatSelectModule,
        ProductCardComponent,
        ProductCardAltComponent,
        PaymentSuffixPipe,
        TruncatePipe,
        ProductDetailsDialogComponent,
        MatPaginatorModule,
        CategoryFilterComponent,
        StepDisplayPromotionComponent,
    ],
    providers: [
        {
            provide: STEPPER_GLOBAL_OPTIONS,
            useValue: { displayDefaultIndicatorType: false },
        },
    ],
})
export class SaleModule {
    //
}
